import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import requestStatus from 'common/constants/status';
import StyledAvailabilityRepeatButton from 'common/theme/availability/StyledAvailabilityRepeatButton';
import { getStartEndDatesFromView } from 'common/utils/availability';
import useAvailabilityRepeat from 'hooks/availability/useAvailabilityRepeat';

function AvailabilityRepeatButton({ calendar = null }) {
  const { t } = useTranslation(['buttons']);

  const repeatStatus = useSelector((state) => state.availability.status.repeat);
  const availabilities = useSelector((state) => state.availability.data.availabilities);

  const { handleRepeat } = useAvailabilityRepeat();

  if (!calendar) return null;

  const dateRange = getStartEndDatesFromView(calendar);

  // Check if there are saved availabilities in the current date range
  const hasSavedAvailabilities = availabilities.some((availability) => {
    const availStart = new Date(availability.start);
    const rangeStart = new Date(dateRange.startDate);
    const rangeEnd = new Date(dateRange.endDate);
    const isStored = availability.extendedProps?.stored || false;
    return isStored && availStart >= rangeStart && availStart <= rangeEnd;
  });

  const isDisabled = !hasSavedAvailabilities || repeatStatus === requestStatus.loading;

  const handleClick = () => {
    handleRepeat(dateRange);
  };

  return (
    <StyledAvailabilityRepeatButton
      onClick={handleClick}
      disabled={isDisabled}>
      <span>{t('repeatAvailability', { ns: 'buttons' })}</span>
    </StyledAvailabilityRepeatButton>
  );
}

AvailabilityRepeatButton.propTypes = {
  calendar: PropTypes.object
};

export default AvailabilityRepeatButton;
